import React, { useMemo, useState } from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import { useDispatch, useSelector } from "react-redux";
import { getUIProperty, setUIProperty } from "../../redux/slices/uiSlice";
import { ScrollView, TextArea } from "devextreme-react";
import { Typography } from "@material-ui/core";
import { itemGridColumns } from "./config";
import { tabNames } from "../../utils/strings";
import { startCase } from "lodash";

const InsertFromCsvModal = ({ setVisible, visible, tabName }) => {
  const dispatch = useDispatch();
  const [columnsToInsert, setColumnsToInsert] = useState({});

  const filteredItems = useSelector((state) =>
    getUIProperty(state, "filteredItems")
  );

  console.log({ filteredItems });
  const columns = useMemo(() => {
    const columnConfig =
      itemGridColumns[tabName || tabNames[0]] || itemGridColumns[tabNames[0]];

    return columnConfig
      .map((cc) => cc.dataField)
      .filter((field) => field !== "totalValue");
  }, [tabName]);

  const handleFieldChange = (value, column) => {
    setColumnsToInsert((prev) => ({ ...prev, [column]: value }));
  };

  const numberOfRows = useMemo(() => {
    const maxRows = Object.keys(columnsToInsert).reduce((acc, key) => {
      const value = columnsToInsert[key];
      if (!value) return 0;

      const tempRows = columnsToInsert[key].split("\n").length;

      return tempRows > acc ? tempRows : acc;
    }, 0);

    return maxRows;
  }, [columnsToInsert]);

  const handleImport = () => {
    const newLineItems = Object.keys(columnsToInsert).reduce((acc, key) => {
      const values = columnsToInsert[key].split("\n").filter((h) => h);

      values.forEach((value, idx) => {
        acc[idx] = {
          ...acc[idx],
          [key]: value,
          id: idx + 1,
          //line_number: value,
        };
      });
      console.log({acc});
      return acc;
    }, {});

    dispatch(
      setUIProperty({
        name: "filteredItems",
        value: Object.values(newLineItems),
      })
    );
    setVisible(false);
  };

  const handleUpdate = () => {
    const newFilteredItems = [...filteredItems];

    Object.keys(columnsToInsert).forEach((key) => {
      const columns = columnsToInsert[key].split("\n");

      columns.forEach((column, columnIndex) => {
        newFilteredItems[columnIndex] = {
          ...newFilteredItems[columnIndex],
          [key]: column,
        };
      });
    });
    dispatch(
      setUIProperty({
        name: "filteredItems",
        value: newFilteredItems,
      })
    );
    setVisible(false);
  };

  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Import columns"
      container=".dx-viewport"
      width={550}
      height={770}
    >
      <Typography>Number of rows: {numberOfRows}</Typography>
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        options={{
          icon: "close",
          text: "Close",
          onClick: () => setVisible(false),
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "save",
          text: "Update",
          onClick: handleUpdate,
        }}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "arrowdown",
          text: "Import",
          onClick: handleImport,
        }}
      />
      <ScrollView>
        {columns.map((col, idx) => (
          <div key={idx} style={{ marginBottom: "16px" }}>
            {startCase(col)}:
            <TextArea
              key={idx}
              height={100}
              onValueChanged={(e) => handleFieldChange(e.value, col)}
              value={columnsToInsert[col]}
            />
          </div>
        ))}
      </ScrollView>
    </Popup>
  );
};

export default React.memo(InsertFromCsvModal);
